import { Injectable } from '@angular/core';
import {ArmSession} from '../../../login/login.component';
import {LoginApiService} from '../../api/login/login-api.service';
import {SessionService} from 'ac-infra';
import {fromEvent, interval, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArmSessionService {

  readonly HOUR_IN_MS = 3600000;
  readonly FREQUENCY = 60000;

  azureSessionSubscription;
  clickEvent;
  keydownEvent;
  lastActiveTime;
  private sessionResetCountdownSubject: Subject<void> = new Subject<void>();
  sessionResetCountdown$ = this.sessionResetCountdownSubject.asObservable();

  constructor(private loginApiService: LoginApiService,
              private sessionService: SessionService) {
  }

  startSession(data): void {
    const startTime = data.sessionStartTime ? data.sessionStartTime : Date.now();
    let endTime = this.generateEndTime(data.sessionTimeout, startTime);
    const source = interval(this.FREQUENCY);
    this.lastActiveTime = new Date();

    this.azureSessionSubscription = source.subscribe(() => {
      if (Date.now() >= endTime) {
        if ((Date.now() - this.HOUR_IN_MS) < this.lastActiveTime) {
          this.loginApiService.refreshToken().then(userDetails => {
            this.sessionService.startSession(this.generateSessionObj(userDetails));
            this.sessionResetCountdownSubject.next();

            endTime = this.generateEndTime(data.sessionTimeout);
          }).catch(() => {
            this.unsubscribeObservables();
          });
        } else {
          this.unsubscribeObservables();
        }
      }
    });

    this.clickEvent = fromEvent(document, 'click').subscribe(() => {
      this.lastActiveTime = Date.now();
    });

    this.keydownEvent = fromEvent(document, 'keydown').subscribe(() => {
      this.lastActiveTime = Date.now();
    });
  }

  generateSessionObj(userDetails): any {
    const session: ArmSession = {
      locked: false,
      inactivityPeriod: userDetails.inactivityPeriod,
      sessionTimeout: userDetails.sessionTimeout
    };

    return session;
  }


  private unsubscribeObservables(): void {
    if (this.azureSessionSubscription) {
      this.azureSessionSubscription.unsubscribe();
    }

    if (this.clickEvent) {
      this.clickEvent.unsubscribe();
    }

    if (this.keydownEvent) {
      this.keydownEvent.unsubscribe();
    }
  }

  private generateEndTime(sessionTimeout, startTime = Date.now()): number {
    return startTime + (sessionTimeout * 60 * 60 * 1000) - 300000;
  }
}
